import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-visitation-builder',
  templateUrl: './audit-visitation-builder.component.html',
  styleUrls: ['./audit-visitation-builder.component.scss']
})
export class AuditVisitationBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
